<template>
  <AppModalEdit
    v-model="isShowing"
    :loading="loading"
    :title="title"
    @clickExec="saveEditedItem"
  >
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-text-field v-model="editedItem.name" label="代理店名" />
      </v-layout>
      <v-layout v-if="isEdit" row wrap>
        <v-switch
          v-model="editedItem.status"
          true-value="active"
          false-value="inactive"
          label="Status"
        />
      </v-layout>
      <v-layout row wrap>
        <v-text-field
          v-model="editedItem.email"
          label="管理者のメールアドレス"
        />
      </v-layout>
      <v-layout row wrap justify-start>
        <v-flex xs2 style="position:relative;">
          <span style="position:absolute; top:36%">支払いサイト</span>
        </v-flex>
        <v-flex xs4 style="min-width: 160px; max-width:320px;">
          <v-select
            v-model="editedItem.paymentTerm"
            :items="['翌月', '翌々月', '翌翌々月']"
            placeholder="支払い日を選択して下さい"
            label="支払日"
          />
        </v-flex>
        <v-flex xs3 style="min-width: 120px; max-width:160px;">
          <v-select
            v-model="editedItem.paymentTermDay"
            :items="siteDateList"
            placeholder="選択して下さい"
          />
        </v-flex>
      </v-layout>
      <v-layout row justify-start>
        <v-flex xs2 style="position:relative; min-height: 70px;">
          <span style="position:absolute; top:36%">代理店マージン率</span>
        </v-flex>
        <v-flex xs10 style="max-width:100px;">
          <span v-if="isEdit" style="line-height:60px;"
            >{{ editedItem.defaultAgencyMargin }}%</span
          >
          <v-text-field
            v-else
            v-model.number="editedItem.defaultAgencyMargin"
            @keydown.arrow-down.prevent
            @keydown.arrow-up.prevent
            @wheel.prevent
            type="number"
            append-icon="%"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <SelectSalesAccount
          v-if="account.systemOwnerId"
          v-model="editedItem.salesAccountId"
          :label="account.belongName + '担当者'"
          placeholder="営業担当者を選択（任意）"
          clearable
        />
      </v-layout>
    </v-container>
  </AppModalEdit>
</template>

<script>
import { mapState } from 'vuex'
import { actions, snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import { AddAgencyForm, EditAgencyForm } from '@/models/Agency'
import SelectSalesAccount from '@/components/Shared/CrudUI/SelectSalesAccount'
const defaultNewItem = new AddAgencyForm()
export default {
  components: { SelectSalesAccount },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    pushItem: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      editedItem: {},
      title: '',
      loading: false,
    }
  },
  computed: {
    ...mapState({
      account: state => state.account.account,
    }),
    isShowing: {
      get() {
        return this.value
      },
      set(isDisplay) {
        return this.$emit('input', isDisplay)
      },
    },
    siteDateList() {
      const result = ['末日']
      for (let i = 1; i <= 28; i++) {
        result.push(i + '日')
      }
      return result
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.title = this.isEdit ? '代理店編集' : '代理店登録'
        if (this.isEdit) {
          this.editedItem = Object.assign({}, this.item)
          return
        }
        this.editedItem = { ...defaultNewItem }
        this.editedItem.defaultAgencyMargin = 20
        this.editedItem.status = 'active'
        this.editedItem.paymentTerm = '翌月'
        this.editedItem.paymentTermDay = '末日'
      }
    },
  },
  methods: {
    async saveEditedItem() {
      this.loading = true
      try {
        if (this.isEdit) {
          await this.pushItem(new EditAgencyForm(this.editedItem))
        } else {
          this.editedItem.systemOwnerId = this.$store.getters[
            'account/systemOwnerId'
          ]
          await this.pushItem(new AddAgencyForm(this.editedItem))
        }
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存完了しました',
        })
      } catch (e) {
        this.loading = false
        // todo model経由でpostする、getErrorMessageもmodelに移す
        throw this.getErrorMessage(e.response.data.message)
      }
      this.isShowing = false
      this.loading = false
    },
    getErrorMessage(rowErrMessage) {
      switch (rowErrMessage) {
        case 'SYNTAX : given agency name already exists in the system ':
          return '入力された代理店名はすでに登録されています。'
        default:
          return '保存に失敗しました。'
      }
    },
  },
}
</script>
